import React from 'react';
import Bienvenidos from '../assets/bienvenido.png';
import SomosMasQue from '../assets/somos mas que.png';
import './Principal.css';

const Principal = ({ radioName }) => {
  return (
    <div className="principal-container">
      <div className="welcome-section">
        <img src={Bienvenidos} alt="Bienvenidos" className="welcome-img" />
      </div>
      
      <div className="radio-name-section">
        <h1 className="radio-name gotham-font">{radioName}</h1>
      </div>
      
      <div className="brand-section">
        <img src={SomosMasQue} alt="Somos más que" className="brand-img" />
      </div>
    </div>
  );
};

export default Principal;